import * as React from 'react'
import { getApiErrorMessage } from '../../helpers/error'

type ErrorMessageProps = {
  isError: boolean
  error: any
  className?: string
}

export default function ErrorMessage({ isError, error, className }: ErrorMessageProps) {
  if (!isError) {
    return null
  }

  return <div className={className || 'error-message'}>{getApiErrorMessage(error)}</div>
}
